import { useEffect } from 'react';

/**
 * Scroll-driven reveal hook. Adds `is-visible` to `.reveal` elements when they
 * enter the viewport. Respects prefers-reduced-motion (they are revealed immediately
 * via CSS).
 */
export function useScrollReveal(): void {
  useEffect(() => {
    const prefersReduced = globalThis.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const targets = Array.from(document.querySelectorAll<HTMLElement>('.reveal'));

    if (prefersReduced) {
      targets.forEach((el) => el.classList.add('is-visible'));
      return;
    }

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -8% 0px' },
    );

    targets.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);
}
